import React from "react";
import HomeHeaderSection from "./HomeHeaderSection"; 
import HomeBannerSection from "./HomeBannerSection";
import HomeExploreAppSection from "./HomeExploreAppSection";
import HomeWhyUseSection from "./HomeWhyUseSection";
import HomeFooterSection from "./HomeFooterSection";


export default function HomePage() {
  return (
    <>
      <HomeHeaderSection />
      <HomeBannerSection />
      <HomeExploreAppSection />
      <HomeWhyUseSection />
      <HomeFooterSection />
    </>
  );
}
